import AdminResource from "@/components/site/AdminResource";

function fmtDate(iso) { try { return new Date(iso).toLocaleDateString("id-ID"); } catch { return "-"; } }

export function AdminBerita() {
  return (
    <AdminResource
      title="Berita"
      subtitle="Kelola berita/artikel portal SILAING"
      endpoint="/berita?limit=100"
      adminEndpoint="/admin/berita"
      columns={["Judul", "Kategori", "Tanggal"]}
      renderRow={(it) => [it.judul, it.kategori, fmtDate(it.tanggal)]}
      fields={[
        { name: "judul", label: "Judul", required: true },
        { name: "kategori", label: "Kategori", default: "Umum" },
        { name: "penulis", label: "Penulis", default: "Humas DKP Jabar" },
        { name: "cover", label: "URL Gambar Sampul", placeholder: "https://..." },
        { name: "excerpt", label: "Ringkasan", type: "textarea" },
        { name: "konten", label: "Konten", type: "textarea", required: true },
      ]}
    />
  );
}

export function AdminRegulasi() {
  return (
    <AdminResource
      title="Regulasi"
      subtitle="Peraturan dan dokumen resmi"
      endpoint="/regulasi"
      adminEndpoint="/admin/regulasi"
      columns={["Judul", "Jenis", "Tahun"]}
      renderRow={(it) => [it.judul, it.jenis, it.tahun]}
      fields={[
        { name: "judul", label: "Judul Dokumen", required: true },
        { name: "jenis", label: "Jenis", default: "Perda", placeholder: "Perda / Pergub / Kepgub / SOP" },
        { name: "tahun", label: "Tahun", type: "number", default: new Date().getFullYear() },
        { name: "url_dokumen", label: "URL Dokumen (PDF)", default: "#" },
      ]}
    />
  );
}

export function AdminGaleri() {
  return (
    <AdminResource
      title="Galeri"
      subtitle="Foto dokumentasi kegiatan"
      endpoint="/galeri"
      adminEndpoint="/admin/galeri"
      columns={["Judul", "Gambar"]}
      renderRow={(it) => [
        it.judul,
        <img key="img" src={it.image} alt="" className="w-12 h-12 rounded-lg object-cover" />,
      ]}
      fields={[
        { name: "judul", label: "Judul Foto", required: true },
        { name: "image", label: "URL Gambar", required: true, placeholder: "https://..." },
      ]}
    />
  );
}

export function AdminAgenda() {
  return (
    <AdminResource
      title="Agenda"
      subtitle="Jadwal kegiatan mendatang"
      endpoint="/agenda"
      adminEndpoint="/admin/agenda"
      columns={["Judul", "Lokasi", "Mulai"]}
      renderRow={(it) => [it.judul, it.lokasi, fmtDate(it.tanggal_mulai)]}
      fields={[
        { name: "judul", label: "Judul Kegiatan", required: true },
        { name: "lokasi", label: "Lokasi" },
        { name: "tanggal_mulai", label: "Tanggal Mulai", type: "date", required: true },
        { name: "tanggal_selesai", label: "Tanggal Selesai", type: "date" },
      ]}
    />
  );
}
